export const FETCH_CLOUDINARY_CONFIG = "FETCH_CLOUDINARY_CONFIG";
export const FETCH_CLOUDINARY_CONFIG_PENDING =
  "FETCH_CLOUDINARY_CONFIG_PENDING";
export const FETCH_CLOUDINARY_CONFIG_REJECTED =
  "FETCH_CLOUDINARY_CONFIG_REJECTED";
export const FETCH_CLOUDINARY_CONFIG_FULFILLED =
  "FETCH_CLOUDINARY_CONFIG_FULFILLED";
